import { BrowserRouter, Route, Routes } from "react-router-dom";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { EntriesPage } from "./EntriesPage";
import { ScanWordsPage } from "./ScanWordsPage";
import { SearchPage } from "./SearchPage";

const StyledApp = styled.div(() => css``);

export function App() {
  return (
    <StyledApp>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SearchPage />} />
          <Route path="/words" element={<ScanWordsPage />} />
          <Route path="/entries" element={<EntriesPage />} />
        </Routes>
      </BrowserRouter>
    </StyledApp>
  );
}
